import { render, staticRenderFns } from "./teacherEvaluationResult.vue?vue&type=template&id=e87f68dc&scoped=true"
import script from "./teacherEvaluationResult.vue?vue&type=script&lang=js"
export * from "./teacherEvaluationResult.vue?vue&type=script&lang=js"
import style0 from "./teacherEvaluationResult.vue?vue&type=style&index=0&id=e87f68dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87f68dc",
  null
  
)

export default component.exports